export default "__VITE_ASSET__CVs2sZ_t__"